import React from 'react'
import { Card } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import RenderComponentBasedOnBlock from '../RenderBasedOnBlock';
import useStyles from './style';
import { Tooltip } from '@material-ui/core';
import { checkConditions } from '../../utils';

const BlockRenderer = (props) => {
    const { blocks, blockState, selectedDataModel } = props;
    const classes = useStyles();
    const selectedStep = {
        dataModel: selectedDataModel,
        blocks: blocks
    }
    return (
        <React.Fragment>
            {blocks?.length > 0 ? (
                (() => {
                    return blocks.map((block, index) => {
                        {
                            return block.subBlock
                                ? block.subBlock.map((res, subIdx) =>
                                    checkConditions(res.conditions, blockState) ? (
                                        <div className={classes.cardContainer} style={{ padding: 0 }} key={`fragment_${block.name}_${index}_sub_${subIdx}`}>
                                            <div className={classes.scrollableContent}>
                                                {
                                                    res.showTitle ? (<Tooltip title={res?.title || ''} arrow>
                                                        <Typography
                                                            component='span'
                                                            noWrap
                                                            className={`${classes.sectionTitleText} ${classes.sectionTitleTextClamp}`}
                                                        >
                                                            {res.title} :
                                                        </Typography>
                                                    </Tooltip>) : null
                                                }
                                                <RenderComponentBasedOnBlock block={res} blockState={blockState} selectedStep={selectedStep} {...props} isSubBlock={true} />
                                            </div>
                                        </div>
                                    ) : null,
                                )
                                : checkConditions(block.conditions, blockState) ? (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                                        <div className={classes.cardContainer} style={{ padding: 0 }} key={`fragment_${block.name}_${index}`}>
                                            <div className={classes.scrollableContent}>
                                                <RenderComponentBasedOnBlock block={block} blockState={blockState} selectedStep={selectedStep} {...props} isSubBlock={false} />
                                            </div>
                                        </div>
                                    </div>

                                ) : null
                        }
                    });
                })()
            ) :
                (
                    <div className={classes.noBlocksContainer}>
                        <Typography>No Blocks configured to display.</Typography>
                    </div>
                )}
        </React.Fragment>
    )
}

export default BlockRenderer
